/**
 * CommunityTour — coach-mark walkthrough for the Community forum landing.
 * Uses the same PageTour engine as the Dashboard + Learning tours.
 */
import React from 'react';
import PageTour from './PageTour';

const STEPS = [
  {
    target: '[data-testid="feed-shell"]',
    title: 'Your community feed',
    body: 'Fresh posts from members you follow and connect with. Share a batch story, ask a question, or drop a link — the composer is right at the top.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="community-side-profile"]',
    title: 'Your profile card',
    body: 'Track your profile strength, edit your headline, photo and banner, and jump straight into your own /u/ page.',
    placement: 'right',
  },
  {
    target: '[data-testid="theme-picker-btn"]',
    title: 'Personal theme',
    body: 'Choose Light or Dark and pick an accent colour — Amber, Blue, Emerald or Violet. Your choice is saved on this device.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="dm-chat-bubble"]',
    title: 'Direct messages',
    body: 'This floating bubble shows unread DMs in real time. Click for a quick preview or open the full inbox.',
    placement: 'left',
  },
  {
    target: '[data-testid="community-hot-topics"]',
    title: 'Hot right now',
    body: 'Trending topics — ranked by views, replies and reactions in the last 24 hours.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="community-just-posted"]',
    title: 'Just posted',
    body: 'Brand-new topics from the last 24 hours, in strict chronological order.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="ambassador-panel-search"]',
    title: 'AI Summarize and Research',
    body: 'Ask any question — the AI searches every active and archived post and answers with links to the source threads.',
    placement: 'top',
  },
  {
    target: '[data-testid="community-subtabs"]',
    title: 'Feed, Categories, Latest and more',
    body: 'The Feed tab is your home base. Switch to Categories, Latest, Top or Bookmarks whenever you want a different view.',
    placement: 'top',
  },
  {
    target: '[data-testid="community-new-topic-btn"]',
    title: 'Start a topic',
    body: 'Post a question, run a poll, announce an event, or share a batch story. Categories keep things organized.',
    placement: 'bottom',
  },
  {
    target: '[data-testid="community-tutorial-link"]',
    title: 'Full written tutorial',
    body: 'Deep-dive guide covering every community feature: connections, endorsements, recommendations, DMs, ads and more.',
    placement: 'bottom',
  },
];

const CommunityTour = ({ forceOpen, onFinish }) => (
  <PageTour
    steps={STEPS}
    storageKey="community_tour_seen_v2"
    forceOpen={forceOpen}
    onFinish={onFinish}
  />
);

export default CommunityTour;
